import { C } from "@/brand/tokens";
import { situations6 } from "@/brand/contentF6";
import { Box6 } from "@/components/common/Box6";
import { Eyebrow6 } from "@/components/common/Eyebrow6";
import { Pill6 } from "@/components/common/Pill6";

/** SituationsSection6 — five boxed buyer situations, scannable by tag alone. */
export function SituationsSection6() {
  return (
    <section id="situations" data-testid="situations-6" style={{ background: C.surfaceLight, color: C.textOnLight }}>
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-10 py-20 lg:py-24">
        <div className="mb-12">
          <Eyebrow6 className="mb-5">{situations6.eyebrow}</Eyebrow6>
          <h2
            className="font-cormorant"
            style={{
              color: C.textOnLight,
              fontSize: "clamp(1.8rem, 3.2vw, 2.6rem)",
              fontWeight: 400,
              lineHeight: 1.08,
              letterSpacing: "-0.012em",
              maxWidth: "26ch",
            }}
          >
            {situations6.headline}
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4" data-testid="situations-grid-6">
          {situations6.tiles.map((t, i) => (
            <Box6 as="article" key={t.n} tone="parchment" radius="resource" className="flex flex-col p-6" data-testid={`situation-tile-${i}`}>
              <div className="flex items-start justify-between gap-3 mb-6">
                <span className="font-cormorant tabular-nums" style={{ color: C.accentMetal, fontSize: "1.5rem", lineHeight: 1 }}>
                  {t.n}
                </span>
                <Pill6 tone="outline">{t.tag}</Pill6>
              </div>
              <p className="font-cormorant" style={{ color: C.textOnLight, fontSize: "1.15rem", fontWeight: 400, lineHeight: 1.3 }}>
                {t.title}
              </p>
            </Box6>
          ))}
        </div>
      </div>
    </section>
  );
}
